import { render } from "./PortletTest.vue?vue&type=template&id=880f18ac&scoped=true"
import script from "./PortletTest.vue?vue&type=script&lang=js"
export * from "./PortletTest.vue?vue&type=script&lang=js"

import "./PortletTest.vue?vue&type=style&index=0&id=880f18ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-880f18ac"]])

export default __exports__